import Tooltip from 'primevue/tooltip';
// Custom tooltip directive that supports both hover and focus events.
// PrimeVue's default tooltip only supports one or the other.
export const vTooltipAccessible = {
    ...Tooltip,
    mounted(el, _binding) {
        const target = el;
        if (target.$_ptooltipModifiers?.focus) {
            // add hover listeners
            if (target.$_ptooltipFocusEvent && target.$_ptooltipBlurEvent) {
                target.$_accessibleMouseEnterEvent = target.$_ptooltipFocusEvent;
                target.$_accessibleMouseLeaveEvent = target.$_ptooltipBlurEvent;
                el.addEventListener('mouseenter', target.$_accessibleMouseEnterEvent);
                el.addEventListener('mouseleave', target.$_accessibleMouseLeaveEvent);
            }
        }
        else {
            // add focus listeners
            if (target.$_ptooltipMouseEnterEvent && target.$_ptooltipMouseLeaveEvent) {
                target.$_accessibleFocusEvent = target.$_ptooltipMouseEnterEvent;
                target.$_accessibleBlurEvent = target.$_ptooltipMouseLeaveEvent;
                el.addEventListener('focus', target.$_accessibleFocusEvent);
                el.addEventListener('blur', target.$_accessibleBlurEvent);
            }
        }
    },
    beforeUnmount(el) {
        const target = el;
        // Clean up our additional event listeners
        if (target.$_ptooltipModifiers?.focus) {
            if (target.$_accessibleMouseEnterEvent) {
                el.removeEventListener('mouseenter', target.$_accessibleMouseEnterEvent);
            }
            if (target.$_accessibleMouseLeaveEvent) {
                el.removeEventListener('mouseleave', target.$_accessibleMouseLeaveEvent);
            }
        }
        else {
            if (target.$_accessibleFocusEvent) {
                el.removeEventListener('focus', target.$_accessibleFocusEvent);
            }
            if (target.$_accessibleBlurEvent) {
                el.removeEventListener('blur', target.$_accessibleBlurEvent);
            }
        }
    }
};
